import React, { useState } from "react";
import { Footer, Navbar } from "../components";
//import  { useState, useEffect } from "react";
const ContactPage = () => {

  const [nombre,setNombre] = useState("");
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Contactanos</h1>
        <hr />
        <div class="row my-4 h-100">
          <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
            <form>
              <div class="form my-3">
                <label for="Name">Nombre</label>
                <input
                  type="email"
                  class="form-control"
                  id="Name"
                  value={nombre}
                  placeholder="Escribe tu nombre"
                  onChange={(e) => setNombre(e.target.value)}
                />
              </div>
              <div class="form my-3">
                <label for="Email">Correo electronico</label>
                <input
                  type="email"
                  class="form-control"
                  id="Email"
                  placeholder="nombre@ejemplo.com"
                />
              </div>
              <div class="form  my-3">
                <label for="Password">Mensaje</label>
                <textarea
                  rows={5}
                  class="form-control"
                  id="Password"
                  placeholder="Escribe tu mensaje"
                />
              </div>
              <div className="text-center">
                <button
                  class="my-2 px-4 mx-auto btn btn-dark"
                  type="submit"
                  disabled
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ContactPage;
